"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _axios = _interopRequireDefault(require("axios"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _clsx = _interopRequireDefault(require("clsx"));
var _formContext = _interopRequireDefault(require("./context/formContext"));
var _Form = _interopRequireDefault(require("./Form.styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Form = props => {
  const css = (0, _Form.default)();
  let {
    absoluteUrl,
    authorization,
    contentType = "formData",
    method = "POST",
    config,
    onAfterSubmit,
    onChange,
    onSubmit,
    ...formProps
  } = props;
  const [formConfig, setFormConfig] = (0, _react.useState)({});
  const [serverResponse, setServerResponse] = (0, _react.useState)({});
  const formRef = (0, _react.useRef)(null);
  const formSendDate = (0, _react.useRef)(null);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const {
    recaptchaRef
  } = formConfig;
  (0, _react.useEffect)(() => {
    if (!(0, _isEmpty.default)(serverResponse)) {
      const sendCompleteDate = new Date();
      const differenceToOneSecond = 1000 - (sendCompleteDate.getTime() - formSendDate.current.getTime());
      const timer = differenceToOneSecond > 0 ? differenceToOneSecond : 0;

      // unlock form

      setTimeout(() => {
        setFormConfig({
          ...formConfig,
          formLocked: false,
          response: serverResponse
        });
      }, timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serverResponse]);
  const handleFormCheck = async e => {
    e.preventDefault();
    const $form = e.target;
    const tmpErrorObj = {};
    $form.querySelectorAll(`*[data-required="true"] input, *[data-required="true"] textarea`).forEach($field => {
      const type = $field.getAttribute("type");
      const value = $field.value;
      const name = $field.getAttribute("name");
      if (type === "text" && !value) tmpErrorObj[name] = true;
      if (type === "hidden" && !value) tmpErrorObj[name] = true;
      if (type === "email" && !value) tmpErrorObj[name] = true;
      if (type === "file" && !value) tmpErrorObj[name] = true;
      if (type === "password" && !value) tmpErrorObj[name] = true;
      if (type === "checkbox" && !$field.checked) tmpErrorObj[name] = true;
      if (!type && !value) tmpErrorObj[name] = true; // textarea or input select
    });

    // has form fields

    if (!(0, _isEmpty.default)(tmpErrorObj)) {
      setFormConfig({
        ...formConfig,
        errorFields: tmpErrorObj
      });
      if (onAfterSubmit) onAfterSubmit({
        errorFields: tmpErrorObj
      });
      return;
    }

    // no errors -> lock form

    setFormConfig({
      ...formConfig,
      formLocked: true,
      errorFields: tmpErrorObj
    });
    if (onAfterSubmit) {
      onAfterSubmit({
        ...formConfig,
        formLocked: true,
        errorFields: tmpErrorObj
      });
    }
    formSendDate.current = new Date();
    if (recaptchaRef?.current) {
      await recaptchaRef.current.executeAsync();
      submitForm($form);
    } else {
      submitForm($form);
    }
  };
  const submitForm = async $form => {
    const formData = new FormData($form);
    const action = $form.getAttribute("action");
    let sendData = null;
    if (config === undefined) {
      config = {};
    }
    if (config.headers === undefined) {
      config.headers = {};
    }
    if (contentType === "formData") {
      sendData = formData;
    } else if (contentType === "json" || "JSON") {
      const object = {};
      formData.forEach((value, key) => object[key] = value);
      sendData = JSON.stringify(object);
      config.headers["Content-Type"] = "application/json";
    }
    if (authorization) {
      const loginToken = localStorage.getItem("logintoken");
      if (loginToken) {
        config.headers["Authorization"] = `Bearer ${loginToken}`;
      }
    }
    switch (method) {
      case "GET":
      case "get":
        {
          const formDataString = new URLSearchParams(sendData).toString();
          if (absoluteUrl) {
            window.location.href = `${action}?${formDataString}`;
            return;
          }
          navigate(`${action}?${formDataString}`);
          break;
        }
      case "CUSTOM":
      case "custom":
        {
          onSubmit(sendData);
          break;
        }
      case "PUT":
      case "put":
        {
          try {
            const response = await _axios.default.put(action, sendData, config);
            setServerResponse(response);
            if (onAfterSubmit) onAfterSubmit(response);
          } catch (error) {
            if (onAfterSubmit) onAfterSubmit({
              httpError: true,
              msg: error
            });
          }
          break;
        }
      case "DELETE":
      case "delete":
        {
          try {
            const response = await _axios.default.delete(action, sendData, config);
            setServerResponse(response);
            if (onAfterSubmit) onAfterSubmit(response);
          } catch (error) {
            if (onAfterSubmit) onAfterSubmit({
              httpError: true,
              msg: error
            });
          }
          break;
        }
      case "POST":
      case "post":
      default:
        {
          try {
            const response = await _axios.default.post(action, sendData, config);
            setServerResponse(response);
            if (onAfterSubmit) onAfterSubmit(response);
          } catch (error) {
            if (onAfterSubmit) onAfterSubmit({
              httpError: true,
              msg: error
            });
          }
          break;
        }
    }
  };
  return /*#__PURE__*/_react.default.createElement("form", _extends({
    className: (0, _clsx.default)(css.form, "mco-form"),
    ref: formRef,
    onChange: () => {
      if (typeof onChange === "function") {
        const formData = new FormData(formRef?.current);
        onChange(formData);
      }
    },
    onSubmit: handleFormCheck
  }, formProps), /*#__PURE__*/_react.default.createElement(_formContext.default.Provider, {
    value: [formConfig, setFormConfig]
  }, props.children));
};
var _default = exports.default = Form;